"use client";

import { Suspense, lazy } from "react";

const Features = lazy(() => import("../components/Features/Features"));
const Articles = lazy(() => import("../components/Articles"));
const Collapsible = lazy(() => import("../components/Collapsible"));
const Documents = lazy(() => import("../components/Documents"));
const ContactForm = lazy(() => import("../components/ContactForm"));
const Form = lazy(() => import("../components/Form"));
const Map = lazy(() => import("../components/Map"));

type SectionProps = {
  section: any;
  index?: number;
};

const SectionClient: React.FC<SectionProps> = (props) => {
  const { section, index } = props;

  if (!!section.hidden) {
    return null;
  }

  switch (section.__component) {
    case "sections.features":
      return (
        <Suspense fallback={null}>
          <Features data={section} />
        </Suspense>
      );
    case "sections.articles":
      return (
        <Suspense fallback={null}>
          <Articles data={section} />
        </Suspense>
      );
    case "sections.collapsible-group":
      return (
        <Suspense fallback={null}>
          <Collapsible data={section} />
        </Suspense>
      );
    case "sections.map":
      return (
        <Suspense fallback={null}>
          <Map />
        </Suspense>
      );
    case "sections.form":
      return (
        <Suspense fallback={null}>
          <Form data={section} />
        </Suspense>
      );
    case "sections.contact-form":
      return (
        <Suspense fallback={null}>
          <ContactForm data={section} />
        </Suspense>
      );
    case "sections.documents-section":
      return (
        <Suspense fallback={null}>
          <Documents data={section} />
        </Suspense>
      );
    default:
      return null;
  }
};

export default SectionClient;
